/** @flow */
import * as React from 'react';
import { withTheme } from 'styled-components';
import { translate } from 'react-i18next';
import ChoroplethReachMap from 'statsradio/components/maps/ChoroplethReachMap';
import GeolocationReach from 'statsradio/modules/dashboard/domain/GeolocationReach';
import GeoMapLayout from '../../../../domain/GeoMapLayout';

type Props = {
  geolocalisation: GeolocationReach[];
  layout: GeoMapLayout;
  theme: Object;
  zoomable?: boolean;
  height: number;
  t: any;
}

function GeoMap({ geolocalisation, layout, t, theme, zoomable, height }: Props) {
  return (
    <ChoroplethReachMap
      id="geomap"
      map={layout.map}
      geolocalisation={geolocalisation}
      viewport={layout.mapBounds}
      zoomable={zoomable}
      height={height}
      reachLabel={t('reach')}
      theme={{
        minColor: '#ede6f5',
        maxColor: theme.V3.colors.geolocation,
        hoverColor: theme.V3.colors.geolocation,
        tooltipBackgroundColor: theme.V3.colors.surface,
      }}
    />
  );
}

export default withTheme(translate()(GeoMap));



// WEBPACK FOOTER //
// ./src/statsradio/modules/dashboard/v2/components/demography/map/GeoMap.js